/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wie gross eine Inhaltsseite ist.
 * 
 *   WIDTH_HEIGHT   — feste Breite und Hoehe in Prozent des Fensters.
 *   ASPECT_RATIO   — festes Seitenverhaeltnis (Vorgabe 2/3); die Seite
 *                    wird so gross wie moeglich, behaelt aber ihr
 *                    Format — auf einem Telefon ist sie damit SCHMALER
 *                    als Kopf- und Fussbereich.
 *   FUELLT_FLAECHE — die Seite nimmt genau die Flaeche zwischen Kopf und
 *                    Fuss ein, ohne Verhaeltnis und ohne festes Mass.
 * 
 * FUELLT_FLAECHE auf Wunsch des Betreibers (14.09.2026): Auf dem Telefon
 * war der Kopfbereich 390 px breit und die Karte 321 px — „der Kopf und
 * Fussbereich wird anders angezeigt als der Inhalt". Mit festen Massen
 * (WIDTH_HEIGHT) muesste die Hoehe bei jeder Aenderung an Kopf oder Fuss
 * nachgezogen werden; dieser Modus braucht das nicht.
 * @export
 */
export const DatabasePageSizeMode = {
    WidthHeight: 'WIDTH_HEIGHT',
    AspectRatio: 'ASPECT_RATIO',
    FuelltFlaeche: 'FUELLT_FLAECHE'
} as const;
export type DatabasePageSizeMode = typeof DatabasePageSizeMode[keyof typeof DatabasePageSizeMode];


export function DatabasePageSizeModeFromJSON(json: any): DatabasePageSizeMode {
    return DatabasePageSizeModeFromJSONTyped(json, false);
}

export function DatabasePageSizeModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePageSizeMode {
    return json as DatabasePageSizeMode;
}

export function DatabasePageSizeModeToJSON(value?: DatabasePageSizeMode | null): any {
    return value as any;
}

